export const unlockAudioContext = () => {
    const audio = new Audio('https://dante-public-files.lon1.cdn.digitaloceanspaces.com/notification_sound.mp3');
    audio.muted = true;
    audio.play()
      .then(() => console.log('Audio context unlocked.'))
      .catch((error) => console.error('Failed to unlock audio context:', error));
  };
  
  export const showNotificationWithSound = (title, options) => {
    const audio = new Audio('https://dante-public-files.lon1.cdn.digitaloceanspaces.com/notification_sound.mp3');
  
    if (Notification.permission === 'granted') {
      new Notification(title, options);
      audio.play().catch((error) => console.error('Audio play error:', error));
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          new Notification(title, options);
          audio.play().catch((error) => console.error('Audio play error:', error));
        }
      });
    }
  };
  